import React from "react";
import "./App.css";
import IndexRouter from "./routers";
import "./i18n";

const App: React.FC = () => {
  return <IndexRouter />;
};

export default App;
